const CARSALE = [
    {
        url: 'car_1.jpeg',
        name: 'Suzuki',
        desc: 'Ignis',
        offer: '$10,000',
        deal: '$15,500',
        km: '42,990 km',
        area: 'Western Australia'
    },
    {
        url: 'car-2.jpg',
        name: 'Toyota',
        desc: 'Land Cruiser Prado',
        offer: '$28,000',
        deal: '$34,000',
        km: '94,590 km',
        area: 'Western Australia'
    },
    {
        url: 'car_3.jpeg',
        name: 'Jeep',
        desc: 'Grand Cherokee',
        offer: '$66,200',
        deal: '$70,700',
        km: '4,260 km',
        area: 'Western Australia'
    },
    {
        url: 'car_4.jpeg',
        name: 'Toyota',
        desc: 'Hilux',
        offer: '$49,189',
        deal: '$53,000',
        km: '49,587 km',
        area: 'Western Australia'
    },
    {
        url: 'car_5.jpeg',
        name: 'Toyota',
        desc: 'Camry',
        offer: '$18,000',
        deal: '$22,000',
        km: '15,329 km',
        area: 'Western Australia'
    },
    {
        url: 'car_6.jpeg',
        name: 'Hyundai',
        desc: 'Accent',
        offer: '$7,000',
        deal: '$10,500',
        km: '127,000 km',
        area: 'Western Australia'
    },
    {
        url: 'car_7.jpeg',
        name: 'Nissan',
        desc: 'Qashqai',
        offer: '$23,500',
        deal: '$26,450',
        km: '40,814 km',
        area: 'Western Australia'
    },
    {
        url: 'car_8.jpeg',
        name: 'Mitsubishi',
        desc: 'Pajero Sport',
        offer: '$33,000',
        deal: '$36,300',
        km: '43,483 km',
        area: 'Western Australia'
    },
    {
        url: 'car_9.jpeg',
        name: 'Holden',
        desc: 'Commodore SS-V',
        offer: '$47,000',
        deal: '$51,800',
        km: '79,000 km',
        area: 'Western Australia'
    },
    {
        url: 'car_10.jpeg',
        name: 'Mazda',
        desc: 'CX-9',
        offer: '$28,000',
        deal: '$31,000',
        km: '116,592 km',
        area: 'Western Australia'
    },
    {
        url: 'car-11.jpeg',
        name: 'Volkswagen',
        desc: 'Touareg',
        offer: '$48,000',
        deal: '$52,000',
        km: '97,000 km',
        area: 'Western Australia'
    }
]

const QUESTIONS = [
    {
        id: 'question-1',
        question: `Where is AutoFlip based?`,
        answer: `AutoFlip is based in Australia - with offices in Melbourne, Sydney, and Perth.`,
        isActive: false
    },
    {
        id: 'question-2',
        question: `How long has AutoFlip been around for?`,
        answer: `AutoFlip is a subsidiary of IDOM Inc. that has over 25 years' experience in the used car industry.`,
        isActive: false
    },
    {
        id: 'question-3',
        question: `Do you have buyers all over Australia?`,
        answer: `Yes, our network of dealers buys cars across Australia.`,
        isActive: false
    },
    {
        id: 'question-4',
        question: `I have got my car advertised online already, how can you get me a better deal?`,
        answer: `At AutoFlip, we tap into our extensive network of trusted dealers across Australia and negotiate the best price for your car fast.<br/><br/>Unlike other online platforms, we can offer you the highest price fast, so that you don't have to deal with timewasters.`,
        isActive: false
    },
    {
        id: 'question-5',
        question: `What is the difference between using AutoFlip and selling directly to a car dealership?`,
        answer: `If you sell your car directly to a dealership, you have to drive around to multiple dealers to compare their offers, which can be frustrating and time-consuming.<br/><br/>With AutoFlip, you can do this from the comfort of your home! We submit your car to our large network of dealers who put forward competitive bids and offer you the best price. We even arrange the car pick-up from your home so there is no need to leave your couch.`,
        isActive: false
    },
    {
        id: 'question-6',
        question: `How do I get paid?`,
        answer: `Once we find the best price for your car, the buyer will get in touch with you to arrange the pick-up and cash transfer.`,
        isActive: false
    },
    {
        id: 'question-7',
        question: `Can you buy my car if I still owe money through finance?`,
        answer: `Yes, we can assist by liaising with the buyer and your finance company. We'll ensure that any outstanding finances owed are paid and that the remaining amount is paid directly to you.`,
        isActive: false
    },
    {
        id: 'question-8',
        question: `How does AutoFlip estimate the value of my car?`,
        answer: `We can assess your car's estimated price based on the details that you provide about your car, such as odometer reading, internal and external condition, damage, accessories, etc. Please note that the estimate is based on the market values from across Australia.`,
        isActive: false
    },
    {
        id: 'question-9',
        question: `How is my car's final sale price determined?`,
        answer: `The final value of your car is determined by the highest offer by our trusted network of dealers. Sale prices can vary depending on your car's conditions, accessories, etc., as well as current market demand.`,
        isActive: false
    }
]

export const LASTEST_DEAL = [
    {
        url: 'img_1.jpg',
        name: 'Toyota',
        desc: 'Rav4',
        deal: '$19,700',
        km: '52,765 km',
    },
    {
        url: 'img_2.jpg',
        name: 'BMW',
        desc: 'X1',
        deal: '$33,200',
        km: '29,500 km',
    },
    {
        url: 'img_3.jpg',
        name: 'Volkswagen',
        desc: 'Polo',
        deal: '$13,500',
        km: '20,241 km',
    },
]
export default {
    CARSALE: CARSALE,
    QUESTIONS: QUESTIONS,
}

export const CAR_REVIEWS = [
    {
        img: 'man_review.png',
        name: 'Rochelle',
        area: 'Western Australia',
        car: 'Hyundai i20',
        review: `Extremely prompt replying to emails and answering questions. 
        A great way to sell, especially when you aren't located in a big city, where selling privately might be more difficult. 
        Definitely recommend them.`
    },
    {
        img: 'man_review_2.png',
        name: 'Lisa',
        area: 'Western Australia',
        car: 'Toyota Corolla',
        review: `What a fantastic company! 5 stars from us. Not only was our car sold the same day but the customer service we received was outstanding. We would definitely recommend if you are looking for a hassle free way to sell your car!`
    },
    {
        img: 'man_review_3.png',
        name: 'Karyn',
        area: 'Victoria',
        car: 'Suzuki Swift',
        review: `Easy, simple and a great way to sell your car. Highly Recommend, they made the whole process hassle-free.`
    },
    {
        img: 'man_review_4.png',
        name: 'David',
        area: 'Victoria',
        car: 'Mazda MX5',
        review: `The team at AutoFlip were fantastic to deal with. The team didn't give up and found a buyer for my car, despite some challenges with it being registered interstate. The sale went through smoothly and the whole process was managed professionally and efficiently.`
    },
    {
        img: 'man_review_5.png',
        name: 'James',
        area: 'Victoria',
        car: 'Holden Barina',
        review: `VIC I live in Melbourne and tried to sell my car online. All I received was unrealistic offers from people over SMS. I then uploaded my car on AutoFlip and within 24 hours we settled on a price that was ~2k more than the best offer I had online.`
    },
    {
        img: 'man_review_6.png',
        name: 'Daniel',
        area: 'Western Australia',
        car: 'Mitsubishi Outlander',
        review: `I highly recommend giving AutoFlip a try. The whole process was so easy and the service was fantastic. Shane was awesome to deal with and helped secure the best price for my old Outlander.`
    }
]

export const VEHICLE_DETAILS = [
    {
        label: 'Odometer',
        key: 'kms'
    },
    {
        label: 'Colour',
        key: 'color'
    },
    {
        label: 'Variant',
        key: 'badge'
    },
    {
        label: 'Series',
        key: 'series'
    },
    {
        label: 'Transmission',
        key: 'transmission'
    },
    {
        label: 'Fuel type',
        key: 'fuelType'
    },
    {
        label: 'Body type',
        key: 'bodyType'
    },
    {
        label: 'Drive type',
        key: 'drive'
    },
    {
        label: 'Engine type',
        key: 'engineType'
    },
    {
        src: 'ic_model_year.svg',
        label: 'Model year',
        key: 'model_year'
    }
];

export const EXTERIOR_RATE = [
    {
        val: 1,
        text: "Poor",
        desc: "Car has at least one of these conditions: Has major and minor scratches and dents, tyres need replacement very soon, brake pads need replacement immediately, peeling/flaking/cracking paint, major chips/cracks on the windshield, rust, cracked/broken headlamps, warped/bent rims, or major mechanical issues."
    },
    {
        val: 2,
        text: "Average",
        desc: "Car has at least one of these conditions: Has major and minor scratches or dents, had paint work to cover damages, tyres need replacement relatively soon, brake pads need replacement soon, needs some major and minor repairs or paint, headlamps are foggy, or has minor mechanical issues."
    },
    {
        val: 3,
        text: "Good",
        desc: "Car has at least one of these conditions: Has some visible scuffs and scratches, had paint touch-ups, tyres tread are less than 50% worn, has one minor crack/chip on the windshield, or needs some minor repairs or paint. No mechanical issues."
    },
    {
        val: 4,
        text: "Very Good",
        desc: "Has more than two minor dents or scratches, minor paint damage, and near-new tyres. No mechanical issues."
    },
    {
        val: 5,
        text: "Excellent",
        desc: "Car exterior is like new and may have 1-2 minor scratches or dents. No mechanical issues."
    },
];
export const INTERIOR_RATE = [
    {
        val: 1,
        text: "Poor",
        desc: "Car has at least one of these conditions: Has larger rips or tears, majorly visible stains, major electrical (e.g., window, heating) issues, major functional issues with the entertainment/navigation system, or any other major damages in the interior that requires repairs."
    },
    {
        val: 2,
        text: "Average",
        desc: "Car has at least one of these conditions: Requires some major or minor repairs due to minor rips or tears, visible stains, more than one minor electrical (e.g., window, heating) issues, minor functional issues with the entertainment/navigation system, or visible scuffs or scratches on its system screen."
    },
    {
        val: 3,
        text: "Good",
        desc: "Car has at least one of these conditions: Has minor scratches or scuffs, minor stain on seats, one minor electrical (e.g., window, heating) issue. No functional issues with the entertainment/navigation system but its system screen has minor scuffs or scratches."
    },
    {
        val: 4,
        text: "Very Good",
        desc: "Car has at least one of these conditions: Has more than two minor scratches, has some minor scratches on its entertainment/navigation screen. No rips or tears and no stains."
    },
    {
        val: 5,
        text: "Excellent",
        desc: "Car interior is like new and may have 1-2 minor damages or scratches. Entertainment/navigation screen has no scratches."
    },
];
export const VEHICLE_CONDITIONS = [
    {
        label: 'Servicing provider',
        key: 'serviceHistoryDetail'
    },
    {
        label: 'Tyres needing replacement',
        key: 'tyreReplacement'
    },
];